import { useQuery } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import dayjs from "dayjs";
import { useEffect } from "react";
import { Navigate, Outlet, useRouteError } from "react-router-dom";

import { get } from "api";
import TopNav from "molecules/navbars/TopNav";
import RootError from "pages/RootError";
import { identifyFlagUser } from "services/Flags";
import { setPromotionModalSeen } from "utils/functions";

import LoadingLayout from "./LoadingLayout";

/**
 * Layout route for authenticated users (post-login)
 */
const AppLayoutNoBottomNav = () => {
  const { data: user } = useQuery({
    queryKey: ["/user"],
    queryFn: () => get("/user"),
    staleTime: 1000 * 60 * 2,
  });

  const { data: platform } = useQuery({
    queryKey: ["/platform/current"],
    queryFn: () => get("/platform/current"),
    staleTime: Infinity,
    // TODO: This query throws errors in anonymous contexts on mobile
    useErrorBoundary: false,
  });

  useEffect(() => {
    if (!user || !platform) return;

    identifyFlagUser(
      {
        id: user.id,
        name: user.phoneNumber,
        email: user.email ?? undefined,
      },
      {
        id: platform.id,
        domain: user.platformDomain?.domain ?? undefined,
        created: dayjs(platform.created).toDate(),
      }
    );
  }, [user, platform]);

  return (
    <>
      <LoadingLayout />

      <div className="flex flex-auto">
        <div className="w-full">
          <Outlet />
        </div>
      </div>
    </>
  );
};

export const AppLayoutErrorNoBottomNav = () => {
  const error = useRouteError();

  const { data: logo } = useQuery({
    queryKey: ["/platform"],
    queryFn: () => get("/platform"),
    select: (data) => data.logoImageUrl,
  });

  if (isAxiosError(error) && error.response?.status === 401) {
    setPromotionModalSeen(false);
    return <Navigate to="/signin" />;
  }

  return (
    <>
      <TopNav>{logo && <img src={logo} className="h-8" />}</TopNav>
      <RootError />
    </>
  );
};

export default AppLayoutNoBottomNav;
